import { motion } from "framer-motion"
import Icon from "~/components/icons";
import type { BucketIcon } from "~/types/icon";

interface ItemProps {
  index: number;
  title: string;
  caption: string;
  icon: BucketIcon;
}

export default function Item({ index, icon, title, caption }: ItemProps) {
  return (
    <div
      className="text-white"
    >
      <div>
        <div className="flex items-center gap-2">
          <Icon icon={icon} color="sky" />
          <h3 className="my-3 mt-2 xl:text-xl">{title}</h3>
        </div>
        <p className="text-xs sm:text-base md:text- text-gray-400 xl:text-sm">{caption}</p>
      </div>
    </div>
  );
}
